module.exports = __webpack_public_path__ + "img/1F1E7-1F1EF.1424ceaa.svg";